import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import { FormattedMessage } from 'react-intl';
import { findT } from '@interness/web-core/src/components/_helpers';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import RandomBrandHeaderImages from '@interness/brands-addon/src/components/media/RandomBrandHeaderImages/RandomBrandHeaderImages';
import BrandsSubnavigation from '@interness/brands-addon/src/components/modules/BrandsSubnavigation/BrandsSubnavigation';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import Separator from '@interness/web-core/src/components/structure/Separator/Separator';
import CallToAction from '@interness/web-core/src/components/modules/CallToAction/CallToAction';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import Button from '@interness/web-core/src/components/elements/Button/Button';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import routes from '@interness/web-core/config/routes';
import useTheme from '../../../../useTheme';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const BrandPromoterList = props => {
  const {
    brand,
    lang
  } = props;
  const translations = findT(brand.translations, lang);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Container, null, ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 8
  }, ___EmotionJSX("div", null, ___EmotionJSX(S.StyledImg, {
    fluid: brand.header_images[0].file.localFile.childImageSharp.fluid,
    alt: brand.display_name
  })), ___EmotionJSX(S.ShortDescription, null, translations.short_description ? ___EmotionJSX("p", null, translations.short_description) : ___EmotionJSX(HTMLEllipsis, {
    unsafeHTML: translations.description,
    maxLine: 3,
    ellipsis: '...'
  }))), ___EmotionJSX(Col, {
    md: 4,
    align: 'center'
  }, ___EmotionJSX(Heading, {
    tag: 'h2'
  }, ___EmotionJSX(Logo, {
    title: brand.display_name,
    logo: brand.logo.localFile,
    svgWidth: '240px',
    svgHeight: '80px'
  })), ___EmotionJSX(Button, {
    as: Link,
    to: `${routes[brand.type.type][lang]}/${brand.slug}`,
    title: brand.display_name
  }, ___EmotionJSX(FormattedMessage, {
    id: "templates.brands.moreButton"
  }))))), ___EmotionJSX(Separator, null));
};
const BrandPromoterGrid = props => {
  const {
    brand,
    count,
    lang
  } = props;
  const translations = findT(brand.translations, lang);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(S.Brand, {
    count: count
  }, ___EmotionJSX(Heading, {
    tag: 'h2'
  }, ___EmotionJSX(Logo, {
    title: brand.display_name,
    logo: brand.logo.localFile,
    svgWidth: '240px',
    svgHeight: '80px'
  })), brand.header_images[0] && ___EmotionJSX("div", null, ___EmotionJSX(S.StyledImg, {
    fluid: brand.header_images[0].file.localFile.childImageSharp.fluid,
    alt: brand.display_name,
    loading: "eager"
  })), ___EmotionJSX("h2", null, brand.display_name), ___EmotionJSX(S.ShortDescription, null, translations.short_description ? ___EmotionJSX("p", null, translations.short_description) : ___EmotionJSX(HTMLEllipsis, {
    unsafeHTML: translations.description,
    maxLine: 3,
    ellipsis: '...'
  })), ___EmotionJSX("div", {
    className: "int-link-container"
  }, ___EmotionJSX(Button, {
    as: Link,
    to: `${routes[brand.type.type][lang]}/${brand.slug}`,
    title: brand.display_name
  }, ___EmotionJSX(FormattedMessage, {
    id: "templates.brands.moreButton"
  })))));
};
const BrandsPageTemplate = props => {
  const {
    type,
    lang
  } = props.pageContext;
  const brands = props.data.allDirectusBrands.nodes;
  const {
    config
  } = useTheme();
  const {
    listStyle,
    showTypeDescription
  } = config.templates.brands;
  const brandTypeInfo = props.data.directusBrandTypes;
  const infoTranslations = findT(brandTypeInfo.translations, lang);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: infoTranslations.display_name
  }), ___EmotionJSX(RandomBrandHeaderImages, {
    type: brandTypeInfo.type
  }), ___EmotionJSX(BrandsSubnavigation, {
    type: type
  }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, null, infoTranslations.display_name), showTypeDescription && infoTranslations.description && ___EmotionJSX(S.BrandTypeDescription, {
    dangerouslySetInnerHTML: {
      __html: infoTranslations.description
    }
  }), ___EmotionJSX(Separator, null), listStyle === 'list' ? brands.map(_ref => {
    let {
      brand
    } = _ref;
    return ___EmotionJSX(BrandPromoterList, {
      key: brand.slug,
      brand: brand,
      lang: lang
    });
  }) : ___EmotionJSX(S.PromoterContainer, null, brands.map(_ref2 => {
    let {
      brand
    } = _ref2;
    return ___EmotionJSX(BrandPromoterGrid, {
      key: brand.slug,
      brand: brand,
      lang: lang,
      count: brands.length
    });
  })), ___EmotionJSX("div", {
    style: {
      textAlign: 'center'
    }
  }, ___EmotionJSX(CallToAction, null)), ___EmotionJSX(Spacer, null)));
};
const query = "1527507136";
export default BrandsPageTemplate;